/** @format */

import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'homefield-promotion',
  templateUrl: './promotion.component.html',
  styleUrl: './promotion.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomefieldPromotionComponent {}
